@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-video-layout-1 [data]="data.data" />
    }
    @case (layout.LAYOUT2) {
      <app-video-layout-2 [data]="data.data" />
    }
  }
}
